import { shallowEqual, useSelector } from "react-redux"

export default function useFilter() {
  return useSelector(mapStateToProps, shallowEqual)
}

const mapStateToProps = ({ carsReducer }) => {
  const { filter } = carsReducer

  return { carsFilter: filter }
}
